const PARTICIPATION_STATUSES = {
    CLICK: 'CLICK',
    LEAD: 'LEAD',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    PAID: 'PAID',
};

export default PARTICIPATION_STATUSES;
